import { useLocation } from 'react-router-dom';

import { useIsLoginProcessComplete } from 'auth';
import { onboarding, type RoutePath } from 'constants/routes';

export function useIsOnboarding() {
  const { pathname } = useLocation();
  const isLoginProcessComplete = useIsLoginProcessComplete();
  return !isLoginProcessComplete || onboarding.includes(pathname as RoutePath);
}
